import Box from "@mui/material/Box";

const BoardCell = ({ onClick, cMenu, value }) => {
  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        width: "1.5rem",
        height: "1.5rem",
        backgroundColor:
          value.isMine === true
            ? value.isRevealed && value.isClicked
              ? "red"
              : "#384048"
            : "transparent",
        border: "1px solid #2B2E32",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={() => onClick(value.row, value.col)}
      onContextMenu={(e) => cMenu(e, value.row, value.col)}
    >
      {value.isRevealed === false && (
        <Box
          sx={{
            display: "flex",
            minWidth: "1.5rem",
            height: "1.5rem",
            backgroundColor: "#4C545C",
            border: "3px outset #788088",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {value.isFlagged && (
            <img
              style={{ width: "0.8rem", height: "1rem" }}
              src={"/images/game/flag.png"}
              alt=""
            />
          )}
        </Box>
      )}
      {value.isRevealed === true && value.isFlagged && (
        <Box
          sx={{
            display: "flex",
            minWidth: "1.5rem",
            height: "1.5rem",
            backgroundColor: value.isMine ? "#4C545C" : "#883333",
            border: "3px outset " + (value.isMine ? "#788088" : "#BB6666"),
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "0.8rem", height: "1rem" }}
            src={"/images/game/flag.png"}
            alt=""
          />
        </Box>
      )}
      {value.isRevealed === true && value.isMine && !value.isFlagged && (
        <img
          style={{ width: "1.2rem", height: "1.2rem" }}
          src={"/images/game/mine.png"}
          alt=""
        />
      )}
      {value.isRevealed === true &&
        !value.isMine &&
        value.neighbor === 0 &&
        !value.isFlagged && (
          <Box
            sx={{
              display: "block",
              minWidth: "1.5rem",
              height: "1.5rem",
              backgroundColor: "transparent",
            }}
          ></Box>
        )}
      {value.isRevealed === true &&
        !value.isMine &&
        value.neighbor > 0 &&
        !value.isFlagged && (
          <img
            style={{ width: "0.7rem", height: "1rem" }}
            src={"/images/game/n" + value.neighbor + ".png"}
            alt=""
          />
        )}
    </Box>
  );

  // const Cell = () => {
  //   if (value.isRevealed === false) {
  //     return value.isFlagged ? (
  //       "🚩"
  //     ) : (
  //       <Box
  //         sx={{
  //           display: "block",
  //           minWidth: "1.5rem",
  //           height: "1.5rem",
  //           backgroundColor:"#4C545C",
  //           border:"3px outset #788088",
  //         }}
  //       ></Box>
  //     );
  //   } else if (value.isMine) {
  //     return (
  //       <img
  //         style={{ width: "1.2rem", height: "1.2rem" }}
  //         src={"/images/game/mine.png"}
  //         alt=""
  //       />
  //     );
  //   } else if (value.isEmpty) {
  //     return (
  //       <Box
  //         sx={{
  //           display: "block",
  //           minWidth: "1.5rem",
  //           height: "1.5rem",
  //           backgroundColor: "transparent",
  //         }}
  //       ></Box>
  //     );
  //   }

  //   return (
  //     <img
  //       style={{ width: "0.7rem", height: "1rem" }}
  //       src={"/images/game/n" + value.n + ".png"}
  //       alt=""
  //     />
  //   );
  // };

  // return (
  //   <>
  //     <Box
  //       sx={{
  //         position: "relative",
  //         display: "inline-flex",
  //         width: "1.5rem",
  //         height: "1.5rem",
  //         backgroundColor: value.isMine === true ? "#384048" : "transparent",
  //         border: "1px solid #2B2E32",
  //         justifyContent: "center",
  //         alignItems: "center",
  //       }}
  //     >
  //       <Cell onClick={onClick} />
  //     </Box>
  //   </>
  // );
};

export default BoardCell;
